<div *ngIf="show()" class="relative inline-block text-left w-full">
    <p-splitButton #splitButton label="Export" [model]="items" (onClick)="openSplitButton(splitButton, $event)" [styleClass]="styleClass()" />
</div>